import { render, staticRenderFns } from "./GroupResultsKtiPrint.vue?vue&type=template&id=44cd5c2d"
import script from "./GroupResultsKtiPrint.vue?vue&type=script&lang=js"
export * from "./GroupResultsKtiPrint.vue?vue&type=script&lang=js"
import style0 from "./GroupResultsKtiPrint.vue?vue&type=style&index=0&id=44cd5c2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports